import { render, staticRenderFns } from "./CollegeSpecialty.vue?vue&type=template&id=778777d6&scoped=true"
import script from "./CollegeSpecialty.vue?vue&type=script&lang=js"
export * from "./CollegeSpecialty.vue?vue&type=script&lang=js"
import style0 from "./CollegeSpecialty.vue?vue&type=style&index=0&id=778777d6&prod&scoped=true&lang=less"
import style1 from "./CollegeSpecialty.vue?vue&type=style&index=1&id=778777d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778777d6",
  null
  
)

export default component.exports